/* Note: WORKFLOW_TASK may be added in the future; this could be used to display info about the WF / do WF tasks if requested */

var ModelXref = {
    FILECABINET:  require('./fileCabinet'),
    BIN: require('./bin')
};

module.exports = function(containerAttrs, options) {
    return new ModelXref[containerAttrs.type](containerAttrs, options);
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/container/factory.js
 ** module id = 393
 ** module chunks = 0
 **/